  <div
    class="advice-explanation nes-p-8 nes-bg-secondary-default nes-rounded-container"
  >
    <div class="lg:nes-flex lg:nes-justify-between nes-w-full flex-container">
      <div class="text-container nes-w-full lg:nes-mb-0 nes-pt-0 lg:nes-pt-10">
        <h2
          class="nes-font-bold nes-text-inverse-subdued nes-text-1200 nes-w-full lg:nes-w-6/12"
        >
          {{
            "PRODUCTS." +
              advicedProduct.name.toUpperCase() +
              ".EXPLANATION_TILE.HEADER" | translate
          }}
        </h2>

        <p class="nes-text-inverse-subdued nes-mb-5 nes-max-w-prose">
          {{
            "PRODUCTS." +
              advicedProduct.name.toUpperCase() +
              ".EXPLANATION_TILE.BLOCK_1" | translate
          }}
        </p>

        <p class="nes-text-inverse-subdued nes-mb-5 nes-max-w-prose">
          {{
            "PRODUCTS." +
              advicedProduct.name.toUpperCase() +
              ".EXPLANATION_TILE.BLOCK_2" | translate
          }}
        </p>

        <p class="nes-text-inverse-subdued nes-max-w-prose">
          {{
            "PRODUCTS." +
              advicedProduct.name.toUpperCase() +
              ".EXPLANATION_TILE.BLOCK_3" | translate
          }}
        </p>
      </div>
      <div class="product-container nes-w-full lg:nes-w-6/12">
        <nes-tile-product hover="false" [heading]="advicedProduct.name">
          <div slot="content">
            <nes-text class="nes-mb-3">{{
              tileIllustrationKey | translate
            }}</nes-text>
            <nes-text-list list-type="checked">
              @for (point of spearpoints; track point) {
                <nes-text-list-item>{{ point }}</nes-text-list-item>
              }
            </nes-text-list>
          </div>
          <div slot="footer">
            <nes-price
              class="nes-mb-5"
              [heading]="
                'PRODUCTS,' +
                  advicedProduct.name.toUpperCase() +
                  '.PRODUCT_TILE.ILLUSTRATION' | translate
              "
              [price]="advicedProduct.priceInCents / 100"
              minimum-fraction-digits="2"
              [leadingText]="'ADVICE.FROM' | translate"
              [trailingText]="'ADVICE.USER_PER_MONTH' | translate"
            >
            </nes-price>
            @if (advicedProduct.name === "Pro") {
              <nes-highlight-box size="small" type="info" class="nes-mb-3">
                <div
                  class="nes-w-full nes-flex nes-justify-between nes-text-default"
                >
                  <div class="nes-font-bold">
                    {{
                      "PRODUCTS." +
                        advicedProduct.name.toUpperCase() +
                        ".PRODUCT_TILE.IMPLEMENTATION_COSTS.LABEL" | translate
                    }}
                  </div>
                  <div class="">
                    {{
                      "PRODUCTS." +
                        advicedProduct.name.toUpperCase() +
                        ".PRODUCT_TILE.IMPLEMENTATION_COSTS.TEXT" | translate
                    }}
                  </div>
                </div>
              </nes-highlight-box>
              <nes-highlight-box size="small" type="info" class="nes-mb-6">
                <div
                  class="nes-w-full nes-flex nes-justify-between nes-text-default"
                >
                  <div class="nes-font-bold">
                    {{
                      "PRODUCTS." +
                        advicedProduct.name.toUpperCase() +
                        ".PRODUCT_TILE.STAFFEL_KORTING.LABEL" | translate
                    }}
                  </div>
                  <div>
                    {{
                      "PRODUCTS." +
                        advicedProduct.name.toUpperCase() +
                        ".PRODUCT_TILE.STAFFEL_KORTING.TEXT" | translate
                    }}
                  </div>
                </div>
              </nes-highlight-box>
            } @else {
              <nes-highlight-box size="small" type="info" class="nes-mb-6">
                <div class="nes-text-default">
                  <div class="nes-font-bold">
                    {{
                      "PRODUCTS." +
                        advicedProduct.name.toUpperCase() +
                        ".PRODUCT_TILE.NO_IMPLEMENTATION_COSTS" | translate
                    }}
                  </div>
                </div>
              </nes-highlight-box>
            }
            <nes-button
              (nesOnClick)="orderProduct.emit(advicedProduct.name)"
              variant="brand"
              >{{ explanationButtonText | translate }}</nes-button
            >
          </div>
        </nes-tile-product>
      </div>
    </div>
  </div>